import {mapStringToEnumValue, throwIfUndefined} from '@coolcolduk/util';

/**
 * convert string to enum
 * @param enumObject the enum object
 * @param value value of enum
 * @returns undefined if string does not belong to enum, otherwise return enum
 * @deprecated migrate to util
 */
export function mapStringToEnumValueValidated<T extends {[key: number | string]: string | number}>(
  enumObject: T,
  value: string | number,
  errorMessage?: string,
): T[keyof T] {
  const rtn = mapStringToEnumValue(enumObject, value);
  return throwIfUndefined(rtn, errorMessage ?? `Invalid value for enum ${enumObject}: ${value}`);
}
